"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiylShadeTable = void 0;
const LootTable_1 = __importDefault(require("../../../../structures/LootTable"));
const SimpleMonster_1 = __importDefault(require("../../../../structures/SimpleMonster"));
exports.RiylShadeTable = new LootTable_1.default().every('Riyl remains');
exports.default = new SimpleMonster_1.default({
    id: 1282,
    name: 'Riyl Shade',
    table: exports.RiylShadeTable,
    aliases: ['riyl shade']
});
//# sourceMappingURL=RiylShade.js.map